import { render, staticRenderFns } from "./NeumaticoImageButton.vue?vue&type=template&id=8bc731ea&scoped=true"
import script from "./NeumaticoImageButton.vue?vue&type=script&lang=js"
export * from "./NeumaticoImageButton.vue?vue&type=script&lang=js"
import style0 from "./NeumaticoImageButton.vue?vue&type=style&index=0&id=8bc731ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc731ea",
  null
  
)

export default component.exports